import { SalesOrderStatus } from '@/models/api/commerce-sales-order'
import { Order } from '@spa/store/modules/orderHistory/types'

/**
 * 注文履歴という文脈におけるEngineの注文ステータスは、現時点では
 * commerce_sales_orderにおけるsales_order_statusをそのまま利用できる。
 * 一方で、EngineStatusがSalesOrderStatusと必ずしも一致していなければならないわけではなく、
 * 部分的にpickするなどの利用方法もありうる。
 */
export type EngineStatus = SalesOrderStatus

export interface EngineStatusFactory {
  create(): EngineStatus
}

export class StoreEngineStatusFactory implements EngineStatusFactory {
  constructor(
    private readonly order: Order
  ) {}

  create(): EngineStatus {
    return this.order.salesOrderStatus
  }
}
